module.exports = __webpack_public_path__ + "img/header_logo.c5096a51.svg";